module.exports = __webpack_public_path__ + "img/services_jj.75537385.jpg";